import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

const Icon = styled.span`
  font-size: 16px;
  margin-right: 12px;

  &.fa-check-circle {
    color: ${props => props.theme.bodyColor};
  }

  &.fa-circle-thin {
    color: ${props => props.theme.secondaryColor};
  }
`;

export default function Check({ checked }) {
  const iconClass = {
    'fa-check-circle': checked,
    'fa-circle-thin': !checked,
  };

  return (
    <Icon className={classNames('fa', iconClass)} />
  );
}

Check.propTypes = {
  checked: PropTypes.bool.isRequired,
};
